/**
 * Static registry of every Remix icon the product stores as data (`"drop-line"`) — spec 01-design-system §5.2 / §5.3
 * plus the widget/section icons of 02-constructor §3.2 / §3.6 / §4, the sensor-family / section icons of the seed
 * (apps/api/src/db/seed.ts FAMILIES, packages/shared ELEMENT_DEFAULTS), the glyphs of app/shell/icons.tsx and
 * features/constructor/engine/DataIcon.tsx, and the status glyphs used by shared/ui.
 *
 * Generated from the spec tables (keep it sorted). Add a name here before storing it in a document.
 */
import {
  Ri4kLine,
  RiAB,
  RiAddCircleLine,
  RiAddLargeLine,
  RiAddLine,
  RiAlarmWarningLine,
  RiAlignCenter,
  RiAlignJustify,
  RiAlignLeft,
  RiAlignRight,
  RiArchiveLine,
  RiArrowDownLine,
  RiArrowDownSLine,
  RiArrowGoBackLine,
  RiArrowGoForwardLine,
  RiArrowLeftLine,
  RiArrowLeftRightLine,
  RiArrowLeftSLine,
  RiArrowRightLine,
  RiArrowRightSLine,
  RiArrowUpLine,
  RiArrowUpSLine,
  RiBarChart2Fill,
  RiBarChart2Line,
  RiBarChartFill,
  RiBaseStationLine,
  RiBold,
  RiBookOpenLine,
  RiBox3Line,
  RiBroadcastLine,
  RiBuilding2Line,
  RiBuildingLine,
  RiCalendar2Line,
  RiCalendarLine,
  RiCameraLine,
  RiChatHistoryLine,
  RiChatSettingsLine,
  RiCheckFill,
  RiCheckLine,
  RiCheckboxBlankCircleLine,
  RiCheckboxCircleFill,
  RiCheckboxCircleLine,
  RiCircleLine,
  RiClockwiseLine,
  RiCloseCircleFill,
  RiCloseCircleLine,
  RiCloseFill,
  RiCloseLargeLine,
  RiCloseLine,
  RiCodeSSlashLine,
  RiCollapseDiagonal2Line,
  RiCompass3Line,
  RiComputerLine,
  RiContrastDropLine,
  RiDashboard2Line,
  RiDashboard3Line,
  RiDashboardHorizontalLine,
  RiDashboardLine,
  RiDatabase2Line,
  RiDeleteBin2Fill,
  RiDeleteBin7Line,
  RiDeleteBinLine,
  RiDoubleQuotesL,
  RiDownload2Line,
  RiDownloadLine,
  RiDragMove2Line,
  RiDraggable,
  RiDropFill,
  RiDropLine,
  RiEarthLine,
  RiEarthquakeLine,
  RiEqualizer3Fill,
  RiErrorWarningFill,
  RiErrorWarningLine,
  RiExchange2Line,
  RiExpandDiagonalLine,
  RiExpandUpDownLine,
  RiExternalLinkLine,
  RiEyeCloseLine,
  RiEyeLine,
  RiEyeOffLine,
  RiFile3Line,
  RiFileAddLine,
  RiFileChartLine,
  RiFileCopyLine,
  RiFileDamageLine,
  RiFileEditLine,
  RiFileExcelLine,
  RiFileGifLine,
  RiFileLine,
  RiFilePdf2Line,
  RiFilePdfLine,
  RiFilePptLine,
  RiFileTextLine,
  RiFileWordLine,
  RiFilter3Line,
  RiFilterLine,
  RiFlashlightLine,
  RiFloodLine,
  RiFocus3Line,
  RiFolder6Line,
  RiFolderAddLine,
  RiFolderFill,
  RiFolderLine,
  RiFolderOpenFill,
  RiFolderOpenLine,
  RiFontColor,
  RiFormatClear,
  RiFullscreenFill,
  RiFullscreenLine,
  RiFunctions,
  RiGlobalLine,
  RiGovernmentLine,
  RiGpsLine,
  RiGridLine,
  RiGroupLine,
  RiHeading,
  RiHistoryLine,
  RiHome2Line,
  RiImageAddLine,
  RiImageCircleLine,
  RiImageLine,
  RiLandscapeLine,
  RiInformation2Line,
  RiInformationFill,
  RiInformationLine,
  RiItalic,
  RiKey2Line,
  RiKeyboardLine,
  RiLayoutGridLine,
  RiLayoutLeftLine,
  RiLayoutMasonryLine,
  RiLineChartLine,
  RiLink,
  RiLinkM,
  RiListCheck,
  RiListOrdered,
  RiListUnordered,
  RiLoader2Fill,
  RiLoader4Line,
  RiLoaderFill,
  RiLock2Line,
  RiLockLine,
  RiLockStarLine,
  RiLockUnlockLine,
  RiLoginBoxLine,
  RiLogoutBoxLine,
  RiLogoutBoxRLine,
  RiMap2Line,
  RiMapPin2Line,
  RiMapPinFill,
  RiMapPinLine,
  RiMoonLine,
  RiMore2Fill,
  RiMore2Line,
  RiMoreFill,
  RiMoreLine,
  RiNotification2Line,
  RiNotification3Line,
  RiPaintBrushLine,
  RiPencilLine,
  RiPieChart2Line,
  RiPieChartLine,
  RiPlayCircleFill,
  RiPlayCircleLine,
  RiPlayFill,
  RiPlayLine,
  RiPlugLine,
  RiPriceTag3Line,
  RiPulseLine,
  RiQuestionLine,
  RiRefreshLine,
  RiRepeat2Fill,
  RiRfidFill,
  RiRfidLine,
  RiRuler2Line,
  RiRulerLine,
  RiSave2Line,
  RiSaveLine,
  RiScales3Line,
  RiScanLine,
  RiSearchLine,
  RiSensorLine,
  RiServerLine,
  RiSettings2Line,
  RiSettings3Line,
  RiSettings4Line,
  RiSettingsLine,
  RiShapesLine,
  RiShieldCheckLine,
  RiSidebarFoldLine,
  RiSortAsc,
  RiSortDesc,
  RiSpamLine,
  RiSpeedUpLine,
  RiStackFill,
  RiStackLine,
  RiSubtractLine,
  RiSunLine,
  RiTable2,
  RiTable3,
  RiTableAltLine,
  RiTableLine,
  RiTableView,
  RiTeamLine,
  RiTempColdLine,
  RiTempHotLine,
  RiText,
  RiTextBlock,
  RiThermometerLine,
  RiTimeLine,
  RiTimerLine,
  RiUnderline,
  RiUpload2Line,
  RiUploadCloud2Line,
  RiUploadCloudLine,
  RiUploadLine,
  RiUser3Line,
  RiUser6Line,
  RiUserAddLine,
  RiUserFollowLine,
  RiUserForbidLine,
  RiUserLine,
  RiUserSettingsLine,
  RiUserStarLine,
  RiVideoLine,
  RiVolumeDownFill,
  RiWaterFlashLine,
  RiWaterPercentLine,
  RiWindyLine,
  RiZoomInLine,
  RiZoomOutLine,
  type RemixiconComponentType,
} from '@remixicon/react';

export const ICON_REGISTRY = {
  '4k-line': Ri4kLine,
  'a-b': RiAB,
  'add-circle-line': RiAddCircleLine,
  'add-large-line': RiAddLargeLine,
  'add-line': RiAddLine,
  'alarm-warning-line': RiAlarmWarningLine,
  'align-center': RiAlignCenter,
  'align-justify': RiAlignJustify,
  'align-left': RiAlignLeft,
  'align-right': RiAlignRight,
  'archive-line': RiArchiveLine,
  'arrow-down-line': RiArrowDownLine,
  'arrow-down-s-line': RiArrowDownSLine,
  'arrow-go-back-line': RiArrowGoBackLine,
  'arrow-go-forward-line': RiArrowGoForwardLine,
  'arrow-left-line': RiArrowLeftLine,
  'arrow-left-right-line': RiArrowLeftRightLine,
  'arrow-left-s-line': RiArrowLeftSLine,
  'arrow-right-line': RiArrowRightLine,
  'arrow-right-s-line': RiArrowRightSLine,
  'arrow-up-line': RiArrowUpLine,
  'arrow-up-s-line': RiArrowUpSLine,
  'bar-chart-2-fill': RiBarChart2Fill,
  'bar-chart-2-line': RiBarChart2Line,
  'bar-chart-fill': RiBarChartFill,
  'base-station-line': RiBaseStationLine,
  'bold': RiBold,
  'book-open-line': RiBookOpenLine,
  'box-3-line': RiBox3Line,
  'broadcast-line': RiBroadcastLine,
  'building-2-line': RiBuilding2Line,
  'building-line': RiBuildingLine,
  'calendar-2-line': RiCalendar2Line,
  'calendar-line': RiCalendarLine,
  'camera-line': RiCameraLine,
  'chat-history-line': RiChatHistoryLine,
  'chat-settings-line': RiChatSettingsLine,
  'check-fill': RiCheckFill,
  'check-line': RiCheckLine,
  'checkbox-blank-circle-line': RiCheckboxBlankCircleLine,
  'checkbox-circle-fill': RiCheckboxCircleFill,
  'checkbox-circle-line': RiCheckboxCircleLine,
  'circle-line': RiCircleLine,
  'clockwise-line': RiClockwiseLine,
  'close-circle-fill': RiCloseCircleFill,
  'close-circle-line': RiCloseCircleLine,
  'close-fill': RiCloseFill,
  'close-large-line': RiCloseLargeLine,
  'close-line': RiCloseLine,
  'code-s-slash-line': RiCodeSSlashLine,
  'collapse-diagonal-2-line': RiCollapseDiagonal2Line,
  'compass-3-line': RiCompass3Line,
  'computer-line': RiComputerLine,
  'contrast-drop-line': RiContrastDropLine,
  'dashboard-2-line': RiDashboard2Line,
  'dashboard-3-line': RiDashboard3Line,
  'dashboard-horizontal-line': RiDashboardHorizontalLine,
  'dashboard-line': RiDashboardLine,
  'database-2-line': RiDatabase2Line,
  'delete-bin-2-fill': RiDeleteBin2Fill,
  'delete-bin-7-line': RiDeleteBin7Line,
  'delete-bin-line': RiDeleteBinLine,
  'double-quotes-l': RiDoubleQuotesL,
  'download-2-line': RiDownload2Line,
  'download-line': RiDownloadLine,
  'drag-move-2-line': RiDragMove2Line,
  'draggable': RiDraggable,
  'drop-fill': RiDropFill,
  'drop-line': RiDropLine,
  'earth-line': RiEarthLine,
  'earthquake-line': RiEarthquakeLine,
  'equalizer-3-fill': RiEqualizer3Fill,
  'error-warning-fill': RiErrorWarningFill,
  'error-warning-line': RiErrorWarningLine,
  'exchange-2-line': RiExchange2Line,
  'expand-diagonal-line': RiExpandDiagonalLine,
  'expand-up-down-line': RiExpandUpDownLine,
  'external-link-line': RiExternalLinkLine,
  'eye-close-line': RiEyeCloseLine,
  'eye-line': RiEyeLine,
  'eye-off-line': RiEyeOffLine,
  'file-3-line': RiFile3Line,
  'file-add-line': RiFileAddLine,
  'file-chart-line': RiFileChartLine,
  'file-copy-line': RiFileCopyLine,
  'file-damage-line': RiFileDamageLine,
  'file-edit-line': RiFileEditLine,
  'file-excel-line': RiFileExcelLine,
  'file-gif-line': RiFileGifLine,
  'file-line': RiFileLine,
  'file-pdf-2-line': RiFilePdf2Line,
  'file-pdf-line': RiFilePdfLine,
  'file-ppt-line': RiFilePptLine,
  'file-text-line': RiFileTextLine,
  'file-word-line': RiFileWordLine,
  'filter-3-line': RiFilter3Line,
  'filter-line': RiFilterLine,
  'flashlight-line': RiFlashlightLine,
  'flood-line': RiFloodLine,
  'focus-3-line': RiFocus3Line,
  'folder-6-line': RiFolder6Line,
  'folder-add-line': RiFolderAddLine,
  'folder-fill': RiFolderFill,
  'folder-line': RiFolderLine,
  'folder-open-fill': RiFolderOpenFill,
  'folder-open-line': RiFolderOpenLine,
  'font-color': RiFontColor,
  'format-clear': RiFormatClear,
  'fullscreen-fill': RiFullscreenFill,
  'fullscreen-line': RiFullscreenLine,
  'functions': RiFunctions,
  'global-line': RiGlobalLine,
  'government-line': RiGovernmentLine,
  'gps-line': RiGpsLine,
  'grid-line': RiGridLine,
  'group-line': RiGroupLine,
  'heading': RiHeading,
  'history-line': RiHistoryLine,
  'home-2-line': RiHome2Line,
  'image-add-line': RiImageAddLine,
  'image-circle-line': RiImageCircleLine,
  'image-line': RiImageLine,
  'landscape-line': RiLandscapeLine,
  'information-2-line': RiInformation2Line,
  'information-fill': RiInformationFill,
  'information-line': RiInformationLine,
  'italic': RiItalic,
  'key-2-line': RiKey2Line,
  'keyboard-line': RiKeyboardLine,
  'layout-grid-line': RiLayoutGridLine,
  'layout-left-line': RiLayoutLeftLine,
  'layout-masonry-line': RiLayoutMasonryLine,
  'line-chart-line': RiLineChartLine,
  'link': RiLink,
  'link-m': RiLinkM,
  'list-check': RiListCheck,
  'list-ordered': RiListOrdered,
  'list-unordered': RiListUnordered,
  'loader-2-fill': RiLoader2Fill,
  'loader-4-line': RiLoader4Line,
  'loader-fill': RiLoaderFill,
  'lock-2-line': RiLock2Line,
  'lock-line': RiLockLine,
  'lock-star-line': RiLockStarLine,
  'lock-unlock-line': RiLockUnlockLine,
  'login-box-line': RiLoginBoxLine,
  'logout-box-line': RiLogoutBoxLine,
  'logout-box-r-line': RiLogoutBoxRLine,
  'map-2-line': RiMap2Line,
  'map-pin-2-line': RiMapPin2Line,
  'map-pin-fill': RiMapPinFill,
  'map-pin-line': RiMapPinLine,
  'moon-line': RiMoonLine,
  'more-2-fill': RiMore2Fill,
  'more-2-line': RiMore2Line,
  'more-fill': RiMoreFill,
  'more-line': RiMoreLine,
  'notification-2-line': RiNotification2Line,
  'notification-3-line': RiNotification3Line,
  'paint-brush-line': RiPaintBrushLine,
  'pencil-line': RiPencilLine,
  'pie-chart-2-line': RiPieChart2Line,
  'pie-chart-line': RiPieChartLine,
  'play-circle-fill': RiPlayCircleFill,
  'play-circle-line': RiPlayCircleLine,
  'play-fill': RiPlayFill,
  'play-line': RiPlayLine,
  'plug-line': RiPlugLine,
  'price-tag-3-line': RiPriceTag3Line,
  'pulse-line': RiPulseLine,
  'question-line': RiQuestionLine,
  'refresh-line': RiRefreshLine,
  'repeat-2-fill': RiRepeat2Fill,
  'rfid-fill': RiRfidFill,
  'rfid-line': RiRfidLine,
  'ruler-2-line': RiRuler2Line,
  'ruler-line': RiRulerLine,
  'save-2-line': RiSave2Line,
  'save-line': RiSaveLine,
  'scales-3-line': RiScales3Line,
  'scan-line': RiScanLine,
  'search-line': RiSearchLine,
  'sensor-line': RiSensorLine,
  'server-line': RiServerLine,
  'settings-2-line': RiSettings2Line,
  'settings-3-line': RiSettings3Line,
  'settings-4-line': RiSettings4Line,
  'settings-line': RiSettingsLine,
  'shapes-line': RiShapesLine,
  'shield-check-line': RiShieldCheckLine,
  'sidebar-fold-line': RiSidebarFoldLine,
  'sort-asc': RiSortAsc,
  'sort-desc': RiSortDesc,
  'spam-line': RiSpamLine,
  'speed-up-line': RiSpeedUpLine,
  'stack-fill': RiStackFill,
  'stack-line': RiStackLine,
  'subtract-line': RiSubtractLine,
  'sun-line': RiSunLine,
  'table-2': RiTable2,
  'table-3': RiTable3,
  'table-alt-line': RiTableAltLine,
  'table-line': RiTableLine,
  'table-view': RiTableView,
  'team-line': RiTeamLine,
  'temp-cold-line': RiTempColdLine,
  'temp-hot-line': RiTempHotLine,
  'text': RiText,
  'text-block': RiTextBlock,
  'thermometer-line': RiThermometerLine,
  'time-line': RiTimeLine,
  'timer-line': RiTimerLine,
  'underline': RiUnderline,
  'upload-2-line': RiUpload2Line,
  'upload-cloud-2-line': RiUploadCloud2Line,
  'upload-cloud-line': RiUploadCloudLine,
  'upload-line': RiUploadLine,
  'user-3-line': RiUser3Line,
  'user-6-line': RiUser6Line,
  'user-add-line': RiUserAddLine,
  'user-follow-line': RiUserFollowLine,
  'user-forbid-line': RiUserForbidLine,
  'user-line': RiUserLine,
  'user-settings-line': RiUserSettingsLine,
  'user-star-line': RiUserStarLine,
  'video-line': RiVideoLine,
  'volume-down-fill': RiVolumeDownFill,
  'water-flash-line': RiWaterFlashLine,
  'water-percent-line': RiWaterPercentLine,
  'windy-line': RiWindyLine,
  'zoom-in-line': RiZoomInLine,
  'zoom-out-line': RiZoomOutLine,
} as const satisfies Record<string, RemixiconComponentType>;

/** Every registered icon name (sorted) — feed icon pickers with it. */
export type IconName = keyof typeof ICON_REGISTRY;
export const ICON_NAMES = Object.keys(ICON_REGISTRY) as IconName[];
